export const STORE_CATEGORY_OPTIONS = [
  {
    key: "ELECTRONICS",
    label: "Electronique",
    description: "Telephones, accessoires et equipements tech.",
    legacyType: "TECHNOLOGY",
  },
  {
    key: "GENERAL",
    label: "General",
    description: "Produits de stock avec quantites et ventes multi-unites.",
    legacyType: "GENERAL",
  },
  {
    key: "SERVICE_BUSINESS",
    label: "Services",
    description: "Prestations, devis, durees d'intervention et catalogue de services.",
    legacyType: "GENERAL",
  },
  {
    key: "GYM",
    label: "Gym",
    description: "Salle de sport, abonnements, supplements et accessoires fitness.",
    legacyType: "GENERAL",
  },
  {
    key: "CAR_BOUTIQUE",
    label: "Auto / Voitures",
    description: "Catalogue vehicules avec vente, location et fiches detaillees.",
    legacyType: "GENERAL",
  },
  {
    key: "REAL_ESTATE",
    label: "Immobilier",
    description: "Residences, appartements et biens meubles avec galerie et donnees de location.",
    legacyType: "GENERAL",
  },
  {
    key: "FASHION",
    label: "Mode",
    description: "Vetements, chaussures et articles lifestyle.",
    legacyType: "FASHION",
  },
] as const

export function getStoreCategoryOption(category: string) {
  return STORE_CATEGORY_OPTIONS.find((option) => option.key === String(category || "").toUpperCase())
}

export function getStoreLegacyType(category: string) {
  return getStoreCategoryOption(category)?.legacyType || "GENERAL"
}

export function getStoreCategoryLabel(category: string) {
  return getStoreCategoryOption(category)?.label || String(category || "GENERAL").toUpperCase()
}

export function getStoreCategoryTone(category: string) {
  const value = String(category || "").toUpperCase()

  if (value === "GENERAL") return "bg-emerald-100 text-emerald-700"
  if (value === "SERVICE_BUSINESS") return "bg-cyan-100 text-cyan-700"
  if (value === "GYM") return "bg-orange-100 text-orange-700"
  if (value === "CAR_BOUTIQUE") return "bg-amber-100 text-amber-700"
  if (value === "REAL_ESTATE") return "bg-violet-100 text-violet-700"
  if (value === "FASHION") return "bg-pink-100 text-pink-700"
  return "bg-blue-100 text-blue-700"
}
